export default {
  model: {
    prop: 'checked',
    event: 'click',
  },
  props: {
    checked: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    black: Boolean,
  },
  watch: {
    checked(val) {
      this.isChecked = val;
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  computed: {
    isOnModifier() {
      return {
        'switch-button--on': this.isChecked,
        'switch-button--disabled': this.disabled,
        'switch-button--black': this.black,
      };
    },
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.isChecked = !this.isChecked;
        this.$emit('toggle', this.isChecked);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/switch-button/switch-button.js